export default __webpack_public_path__ + "static/avatar-rachel-706a2395480e465f0f8dcb271d65acb3.png";